/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Removing_Repeat_Words_FailedInputs */



/**
* | output |
* | --- |
* | "Removing repeat words failed. {error}" |
*
* @param {Removing_Repeat_Words_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const removing_repeat_words_failed = /** @type {((inputs: Removing_Repeat_Words_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removing_Repeat_Words_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Suppression des mots répétés échouée. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Entfernen von doppelten Wörtern ist fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimozione delle parole ripetute non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удаление повторяющихся слов не удалось. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al eliminar palabras repetidas. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除重复词失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`重複した単語の削除に失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`दोहराए गए शब्दों को हटाने में विफलता। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A remoção de palavras repetidas falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Removing repeat words failed. ${i?.error}`)
});